<template>
    <div>
        <Row><Button icon="md-refresh" shape="circle" @click="$emit('order-refresh')"></Button></Row>
        <ul>
            <li v-for="order in list" :key="order.id" class="margin-top-10">
                <Card :title="order.id">
                    <span slot="extra">
                        <Button v-if="order.is_closed">删除订单</Button>
                        <Button v-else-if="!order.finish_time">关闭订单</Button>
                    </span>
                    <p>订单：{{order.order_content.event}} 【{{order.order_content.rechargeType}}】</p>
                    <p>生成时间 {{new Date(order.create_time).pattern(timePatterns.datetime)}}</p>
                    <div>
                        套餐信息
                        <div class="margin-left-10">
                            <p>套餐名称：{{order.order_content.rechargeOffer.name}}</p>
                            <p>套餐流量：{{order.order_content.rechargeOffer.flow}}</p>
                            <p>套餐单价：<s>￥{{order.order_content.rechargeOffer.originPrice}}</s> ￥{{order.order_content.rechargeOffer.price}}</p>
                            <p v-if="order.order_content.endDate">续费期限：{{new Date(order.order_content.endDate).pattern(timePatterns.month)}}</p>
                        </div>
                    </div>
                    <div>
                        SIM卡：{{order.order_content.simCards.length}} 张 <Button type="dashed" @click="showCards(order.order_content.simCards, order.id)">详细</Button>
                    </div>
                    <div v-if="order.children_num">
                        子订单
                        <div class="margin-left-10">
                            <p>子订单数量：{{order.children_num}}</p>
                            <p>完成数量：{{order.children_complete}}</p>
                        </div>
                    </div>
                    <p>总价：<s>￥{{order.price_total}}</s> ￥{{order.price_real}}</p>
                    <p>已付金额：￥{{order.pay_real}}</p>
                    <p>支付方式：{{payWays[order.pay_way]}}</p>
                    <p>订单状态：{{getOrderStatus(order)}}</p>
                    <p v-if="order.pay_id">支付流水号：{{order.pay_id}}</p>
                    <p v-if="order.pay_time">支付时间: {{new Date(order.pay_time).pattern(timePatterns.datetime)}}</p>
                    <p v-if="order.finish_time">完成时间: {{new Date(order.finish_time).pattern(timePatterns.datetime)}}</p>
                    <Collapse>
                        <Panel name="buyer_remark">
                            备注
                            <div slot="content" >
                                <p v-for="line in (order.buyer_remark||'').split('\n')" :key="line">{{line}}</p>
                            </div>
                        </Panel>
                        <Panel name="seller_remark">
                            平台/管理员消息
                            <div slot="content" >
                                <p v-for="line in (order.seller_remark||'').split('\n')" :key="line">{{line}}</p>
                            </div>
                        </Panel>
                    </Collapse>
                </Card>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "order-list",
        props: {
            list: Array
        },
        data () {
            return {
                payWays: ['电梯云账户付款', '线下支付', '微信支付', '支付宝支付'],
                timePatterns: {
                    date: 'yyyy-MM-dd',
                    datetime: 'yyyy-MM-dd HH:mm:ss',
                    month: 'yyyy-MM'
                },
                tagBR: '<br/>'
            }
        },
        methods: {
            getOrderStatus (order) {
                if (order.is_closed) return '已关闭';
                // if (!pay_time) return '待支付';
                if (!order.finish_time) return '处理中';
                if (order.pay_real == 0) return '订单已结束-充值失败';
                if (order.pay_real < order.price_real) return `订单已结束 - 充值成功：${(100 * order.pay_real / order.price_real).toFixed(2)} %，详情请查看平台消息。`
                return '订单已结束-充值成功';
            },
            showCards (cards, orderId) {
                this.$Modal.info({
                    title: `订单${orderId}`,
                    render: (h) => {
                        let list = [];
                        cards.forEach(card => {
                            list.push(h('li', [card.iccid, ' ', card.amount]));
                        })
                        return h('ul', list)
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>